import { forwardRef } from 'react';
import PropTypes from 'prop-types';

// material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Slide,
  Box,
  Typography
} from '@mui/material';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */

export default function AlertDialog({
  openAlertDialog,
  message,
  title,
  _btnLabel,
  handleClose,
  bulkUploadError,
  exportErrorReport
}) {
  const isNotEmpty = (val) =>
    val !== null && val !== undefined && (typeof val !== 'object' || Object.keys(val).length > 0);
  return (
    <Dialog
      open={openAlertDialog}
      sx={{ zIndex: 10000000 }}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      data-testid="alert-dialog"
    >
      <DialogTitle sx={{ fontFamily: 'Montserrat' }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {(() => {
            if (Array.isArray(message)) {
              return (
                <>
                  {message.map((merchant, _index) => (
                    <Box key={merchant?.rowIndex} sx={{ p: 2 }}>
                      <Typography sx={{ fontWeight: 700, color: 'rgba(195, 10, 10, 1)' }}>
                        Row No {merchant?.rowIndex} has issue
                      </Typography>
                      <Typography sx={{ fontWeight: 600, color: 'rgba(195, 10, 10, 1)' }}>
                        {merchant?.error}
                      </Typography>
                    </Box>
                  ))}
                </>
              );
            }
            if (typeof message === 'object' && message !== null && message !== undefined) {
              const objectKeys = Object.keys(message);
              return (
                <>
                  {objectKeys?.map((key) => (
                    <Box key={key} sx={{ p: 2 }}>
                      <Typography sx={{ fontWeight: 700, color: 'rgba(195, 10, 10, 1)' }}>
                        {key} : {message[key]}
                      </Typography>
                    </Box>
                  ))}
                </>
              );
            }
            return <Typography>{message}</Typography>;
          })()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {isNotEmpty(bulkUploadError) && (
          <Button data-testid="alert-dialog-download" variant="contained" onClick={exportErrorReport}>
            Download
          </Button>
        )}

        <Button data-testid="alert-dialog-ok" variant="outlined" onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  openAlertDialog: PropTypes.bool,
  message: PropTypes.string,
  title: PropTypes.string,
  _btnLabel: PropTypes.string,
  handleClose: PropTypes.func,
  bulkUploadError: PropTypes.object,
  exportErrorReport: PropTypes.func
};
